

import { toggleHeaderNav } from './module/header.js';

document.addEventListener('DOMContentLoaded', function () {
    toggleHeaderNav();
});
